import { baseClient } from './baseRequest';

export type OrderInfo = {
  name: string;
};

const orderClient = {
  getOrderInfo: async (orderName: string): Promise<OrderInfo> => {
    return baseClient.get({
      url: `/orders/${orderName}`,
    });
  },
};

export default orderClient;
